<template>
  <div class="p-4 bg-white rounded-lg h-100">
    <DataTable />
  </div>
</template>

<script>
import DataTable from "@/own/components/orderManagement/returned/DataTableNew.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "Returned",
  components: { DataTable },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
